<template>
<picture :class="className">
  <template v-for="(img,key) in imgset.sizes">
    <source v-if="sizes[key]" :srcset="img" :media="sizes[key]">
  </template>
  <img :src="imgset.sizes.max_650x650" :width="imgset.attributes.width" :height="imgset.attributes.height" />
</picture>
</template>
<script type="text/javascript">
export default {
  props: {
    imgset: {},
    sizes: {},
    className: ''
  },
  mounted: function () {
    if (typeof window.picturefill === 'function') {
      if (window.picturefill && !this.$parent.fillPicCalled) {
        window.picturefill()
        this.$parent.fillPicCalled = true
        var cmp = this
        setTimeout(function () {
          cmp.$parent.fillPicCalled = false
        }, 500)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// VuePicture.vue?5bd1f498